type MobionConvType = "etc" | "join" | "login";

export const mobionPageView = () => {
  window.CallMtm =
    window.CallMtm ||
    function (...args: unknown[]) {
      (window.CallMtm.q = window.CallMtm.q || []).push(args);
    };
  window.CallMtm();
};

export const mobionDataManagerPageView = () => {
  window.callDM =
    window.callDM ||
    function (...args: unknown[]) {
      (window.callDM.q = window.callDM.q || []).push(args);
    };
  window.callDM();
};

export const mobionPixel = (convType: MobionConvType) => {
  window.CallMtm?.({ convType });
};
